import Vue from 'vue'
import Vuex from 'vuex'
import albums from './modules/albums'
import shop from './modules/shop'
import auth from './modules/auth'
import clients from './modules/clients'
import news from './modules/news'
import orders from './modules/orders'
import purchases from "./modules/purchases";
import purchase_access from "./modules/purchase_access";
import payments from "./modules/payments";
import balance_histories from "./modules/balance_histories";
import purchase_histories from "./modules/purchase_histories";
import deliveries from "./modules/deliveries";
import collections from "./modules/collections";
import links from "./modules/links";
import printer from "./modules/printer";
import additional_costs from "./modules/additional_costs";
import unitpay from "./modules/unitpay";
import yookassa from "./modules/yookassa";
import vk from "./modules/vk";
import ok from "./modules/ok";
import products from "./modules/products";
import compositions from "./modules/compositions";
import colors from "./modules/colors";
import options from "./modules/options";
import places from "./modules/places";
import sellers from "./modules/sellers";
import categories from "./modules/categories";
import favourites from "./modules/favourites";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    albums,
    printer,
    shop,
    auth,
    clients,
    news,
    orders,
    purchases,
    purchase_access,
    payments,
    balance_histories,
    purchase_histories,
    deliveries,
    collections,
    additional_costs,
    links,
    unitpay,
    yookassa,
    vk,
    ok,
    products,
    compositions,
    colors,
    options,
    places,
    sellers,
    categories,
    favourites,
  }
})